import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ExportToCsv } from 'export-to-csv';

import { AppComponent } from '../../app.component';
import { HubService } from '../../services/hub.service';
import { Installation } from '../../types/installation';

//import { ExportToCsv } from 'export-to-csv';
export interface Fuel {
    type: string;
    id: string;
}

export interface TrueFalse {
    type: boolean;
    name: string;
}

/**
 * @title Table with sticky columns
 */
@Component({
    selector: 'reports',
    styleUrls: ['reports.component.css'],
    templateUrl: 'reports.component.html',
    providers: [HubService],
})
export class ReportsComponent implements OnInit {
    errorMessage: string;

    installsList = <Installation[]>[];

    loading_data: boolean;
    refresh_allowed: boolean;

    @Output() rowCountEvent = new EventEmitter<string>();
    searchParams = {} as Installation;


    start_offset: number;
    end_offset: number;
    STEP = 200;
    INIT_SIZE = 500;
    LAST_POSITION = 0;

    fuels: Fuel[] = [
        { type: 'Oil', id: 'oil' },
        { type: 'Gas', id: 'gas' },
        { type: 'Other', id: 'other' }
    ];

    truefalse: TrueFalse[] = [
        { type: true, name: "true" },
        { type: false, name: "false" }
    ];

    constructor(
        private hubService: HubService,
        private matDialog: MatDialog,
    ) { }

    ngOnInit(): void {
        if (!AppComponent.IsLoggedIn()) { return; }

        this.start_offset = 0;
        this.loading_data = true;
        this.refresh_allowed = true;

        var temp = {} as Installation;
        this.installsList.push(temp);

        this.initalize(this.searchParams);
    }

    @ViewChild(CdkVirtualScrollViewport)
    public viewPort: CdkVirtualScrollViewport;


    public get inverseOfTranslation(): string {
        if (!this.viewPort || !this.viewPort["_renderedContentOffset"]) {
            return "-0px";
        }
        let offset = this.viewPort["_renderedContentOffset"];
        return `-${offset}px`;
    }

    initalize(search: Installation): void {
        this.start_offset = 0;

        if (this.searchParams.uid) {
            this.searchParams.uid = +this.searchParams.uid;
        }

        if (this.searchParams.unique_id) {
            this.searchParams.unique_id = +this.searchParams.unique_id;
        }

        if (this.searchParams.serial_no) {
            this.searchParams.serial_no = +this.searchParams.serial_no;
        }

        if (this.searchParams.uploaded) {
            this.searchParams.uploaded = new Date(this.searchParams.uploaded);
        }

        if (this.searchParams.created_on) {
            this.searchParams.created_on = new Date(this.searchParams.created_on);
        }
        if (this.searchParams.assigned_date_time) {
            this.searchParams.assigned_date_time = new Date(this.searchParams.assigned_date_time);
        }
        if (this.searchParams.start_time) {
            this.searchParams.start_time = new Date(this.searchParams.start_time);
        }
        if (this.searchParams.end_time) {
            this.searchParams.end_time = new Date(this.searchParams.end_time);
        }
        if (this.searchParams.last_updated_date_time) {
            this.searchParams.last_updated_date_time = new Date(this.searchParams.last_updated_date_time);
        }
        if (this.searchParams.date_corrected) {
            this.searchParams.date_corrected = new Date(this.searchParams.date_corrected);
        }

        console.log(search);
        try {
            this.loading_data = true;
            console.log("loading_data: ", this.loading_data);

            this.hubService.postInstallations("all", this.start_offset, this.INIT_SIZE, search).subscribe(
                InstallDetails => {
                    this.installsList = InstallDetails;
                    this.end_offset = this.INIT_SIZE;
                    if (InstallDetails.length == 0) {
                        var temp = {} as Installation;
                        this.installsList.push(temp);
                    }
                    this.loading_data = false;
                },
                error => this.errorMessage = <any>error,
            );

            this.hubService.postInstallationsCount("all", this.start_offset, this.INIT_SIZE, search, true).subscribe(
                InstallDetails => this.rowCountEvent.emit(InstallDetails.list[0]['count']),
                error => this.errorMessage = <any>error,
            );

        } catch (e) {
            console.log("error............")
            console.log('Meh: ' + e);
        }
    }

    refresh(step: any, down: boolean, event: any, search: Installation): void {
        try {
            //    this.loading = true;
            console.log("refresh loading.........");
            var temp_offset;
            //Scrolling Down
            if (down) {
                temp_offset = this.end_offset;
            }
            //Scrolling Up
            if (!down) {
                temp_offset = this.start_offset;
            }

            event['srcElement']['scrollTop'] = event['srcElement']['scrollHeight'] / 2;

            this.hubService.postInstallations("all", temp_offset, step, search).subscribe(
                InstallDetails => {
                    console.log("Pre Update length: " + this.installsList.length);
                    if (down) {
                        var removed = this.installsList.splice(0, this.STEP);
                        this.installsList = this.installsList.concat(...InstallDetails);
                        this.end_offset += this.STEP;
                        this.start_offset = this.end_offset - this.INIT_SIZE - this.STEP;
                        console.log("Removed Down: " + removed.length + " Start: ", this.start_offset + " End: ", this.end_offset);
                    }

                    if (!down) {
                        var removed = this.installsList.splice((this.end_offset - this.INIT_SIZE), this.STEP);
                        this.installsList = InstallDetails.concat(this.installsList);
                        if (this.end_offset > this.INIT_SIZE) {
                            this.end_offset -= this.STEP;
                        }
                        if (this.start_offset != 0) {
                            this.start_offset = this.start_offset - this.STEP;
                        }
                        console.log("Removed Up: " + removed.length + " Start: ", this.start_offset + " End: ", this.end_offset);
                    }

                    console.log("Post Update length: " + this.installsList.length);
                    console.log("refresh loaded.........");
                    this.refresh_allowed = true;
                },
                error => this.errorMessage = <any>error,
            );
        } catch (e) {
            console.log("error............");
            console.log('Meh: ' + e);
        }
    }

    getColor(c: any): string {
        if (c % 2 == 0) {
            return "#dadada";
        } else {
            return "white"
        }
    }

    scrolled(event: any): void {
        //console.log("--------------------------------");
        //console.log("ScrollTop" + event['srcElement']['scrollTop']);
        //console.log("ScrollHeight" + event['srcElement']['scrollHeight']);
        //console.log("--------------------------------");

        //Scroll Down
        if (this.LAST_POSITION < event['srcElement']['scrollTop']) {
            console.log("Scroll Down page");
            if (event['srcElement']['scrollTop'] > ((event['srcElement']['scrollHeight'] / 4) * 3)) {//3 *2
                if (this.refresh_allowed) {
                    this.refresh_allowed = false;
                    this.refresh(this.STEP, true, event, this.searchParams);
                } else {
                    console.log("NO REFRESH!!!");
                }
            }
        }
        //Scroll Up
        if (this.LAST_POSITION > event['srcElement']['scrollTop']) {
            console.log("Scroll Up page");
            if (event['srcElement']['scrollTop'] < ((event['srcElement']['scrollHeight'] / 4) * 1)) { // 6*1
                if (this.end_offset != this.INIT_SIZE) {
                    if (this.refresh_allowed) {
                        this.refresh_allowed = false;
                        this.refresh(this.STEP, false, event, this.searchParams);
                    } else {
                        console.log("NO REFRESH!!!");
                    }

                }

            }
        }
        this.LAST_POSITION = event['srcElement']['scrollTop'];


    }

    search() {
        //  console.log(this.searchParams);
        this.initalize(this.searchParams);
    }

    cancel(id: string) {
        switch (id) {
            case 'uid':
                this.searchParams.uid = null;
                break;
            case 'job_id':
                this.searchParams.job_id = null;
                break;
            case 'uploaded':
                this.searchParams.uploaded = null;
                break;
            case 'serial_no':
                this.searchParams.serial_no = null;
                break;
            case 'post_code':
                this.searchParams.post_code = null;
                break;
            case 'job_id':
                this.searchParams.job_id = null;
                break;
            case 'created_on':
                this.searchParams.created_on = null;
                break;
            case 'assigned_date_time':
                this.searchParams.assigned_date_time = null;
                break;
            case 'first_name':
                this.searchParams.first_name = null;
                break;
            case 'last_name':
                this.searchParams.last_name = null;
                break;
            case 'address_line_1':
                this.searchParams.address_line_1 = null;
                break;
            case 'address_line_2':
                this.searchParams.address_line_2 = null;
                break;
            case 'address_line_3':
                this.searchParams.address_line_3 = null;
                break;
            case 'city':
                this.searchParams.city = null;
                break;
            case 'job_postal_code':
                this.searchParams.job_postal_code = null;
                break;
            case 'contact_phone':
                this.searchParams.contact_phone = null;
                break;
            case 'contact_mobile':
                this.searchParams.contact_mobile = null;
                break;
            case 'contact_email':
                this.searchParams.contact_email = null;
                break;
            case 'start_time':
                this.searchParams.start_time = null;
                break;
            case 'end_time':
                this.searchParams.end_time = null;
                break;
            case 'status':
                this.searchParams.status = null;
                break;
            case 'notes':
                this.searchParams.notes = null;
                break;
            case 'mprn':
                this.searchParams.mprn = null;
                break;
            case 'eircode':
                this.searchParams.eircode = null;
                break;
            case 'scan_serial_number_of_hub':
                this.searchParams.scan_serial_number_of_hub = null;
                break;
            case 'entered_serial_number_of_hub':
                this.searchParams.entered_serial_number_of_hub = null;
                break;
            case 'start_job':
                this.searchParams.start_job = null;
                break;
            case 'gprn':
                this.searchParams.gprn = null;
                break;
            case 'last_updated_date_time':
                this.searchParams.last_updated_date_time = null;
                break;
            case 'geopal_data':
                this.searchParams.geopal_data = null;
                break;
            case 'process_error':
                this.searchParams.process_error = null;
                break;
            case 'assignedto':
                this.searchParams.assignedto = null;
                break;
            case 'installerid':
                this.searchParams.installerid = null;
                break;
            case 'date_corrected':
                this.searchParams.date_corrected = null;
                break;
            case 'unique_id':
                this.searchParams.unique_id = null;
                break;
        }

        this.initalize(this.searchParams);
    }

    // Add() {
    //     this.exportInstallationsCSV();
    //     console.log(this.searchParams);
    // }

    updateInstallation(uid: number, update: any, event: any) {
        var installationDetails = <Installation[]>[];
        var tempInstallation = new Installation;

        console.log(event);
        tempInstallation.uid = uid;
        switch (event) {
            case "next_serial_no": {
                tempInstallation.serial_no = +update;
                break;
            }
            case "next_post_code": {
                tempInstallation.post_code = update;
                break;
            }
            case "next_first_name": {
                tempInstallation.first_name = update;
                break;
            }
            case "next_last_name": {
                tempInstallation.last_name = update;
                break;
            }
            case "next_address_line_1": {
                tempInstallation.address_line_1 = update;
                break;
            }
            case "next_address_line_2": {
                tempInstallation.address_line_2 = update;
                break;
            }
            case "next_address_line_3": {
                tempInstallation.address_line_3 = update;
                break;
            }
            case "next_city": {
                tempInstallation.city = update;
                break;
            }
            case "next_job_postal_code": {
                tempInstallation.job_postal_code = update;
                break;
            }
            case "next_contact_phone": {
                tempInstallation.contact_phone = update;
                break;
            }
            case "next_contact_mobile": {
                tempInstallation.contact_mobile = update;
                break;
            }
            case "next_contact_email": {
                tempInstallation.contact_email = update;
                break;
            }
            case "next_notes": {
                tempInstallation.notes = update;
                break;
            }
            case "next_mprn": {
                tempInstallation.mprn = update;
                break;
            }
            case "next_eircode": {
                tempInstallation.eircode = update;
                break;
            }
            case "next_scan_serial_number_of_hub": {
                tempInstallation.scan_serial_number_of_hub = update;
                break;
            }
            case "next_entered_serial_number_of_hub": {
                tempInstallation.entered_serial_number_of_hub = update;
                break;
            }
            case "next_gprn": {
                tempInstallation.gprn = update;
                break;
            }
            case "next_assignedto": {
                tempInstallation.assignedto = update;
                break;
            }
            case "next_installerid": {
                tempInstallation.installerid = update;
                break;
            }
            case "next_date_corrected": {
                tempInstallation.date_corrected = new Date(update);
                break;
            }
            case "next_unique_id": {
                tempInstallation.unique_id = +update;
                break;
            }
        }

        installationDetails.push(tempInstallation);
        console.log(installationDetails);
        this.hubService.writeInstallationDetails(installationDetails)
            .subscribe(
                data => console.log(data.status),
                error => this.errorMessage = <any>error,
            );
    }

    exportInstallationsCSV(): void {
        let tempDate = new Date().toLocaleString();
        try {
            this.hubService.postInstallationsCsv([]).subscribe(
                installationsCsv => {
                    console.log(installationsCsv);
                    const options = {
                        filename: `GeopalInstallationReports_${tempDate}`,
                        useKeysAsHeaders: true,
                    };
                    const csvExporter = new ExportToCsv(options);
                    csvExporter.generateCsv(installationsCsv);
                },
                error => this.errorMessage = <any>error,
            );
        } catch (e) {
            console.log('exportInstallationsCSV error: ' + e);
        }
    }

}


